<template>
  <layout>
    <page-header :actions="actions" :header="$t('drivers.title')" />
    <div class="content">
      <admin-table v-if="currentDivision" v-bind="tableProps">
        <template slot="name" slot-scope="{ item }">
          <div class="media">
            <div class="media-left mr-2">
              <div class="h-10 w-10">
                <img
                  v-if="item.photo && item.photo.url"
                  :src="thumb(item.photo, 60, 60, true)"
                  class="rounded-full max-w-full"
                  alt=""
                />
                <avatar
                  v-else
                  :username="item.name"
                  :size="40"
                  :custom-style="{ maxWidth: '100%', maxHeight: '100%' }"
                  :rounded="true"
                />
              </div>
            </div>
            <div class="media-body">
              <div>{{ item.name }}</div>
              <div class="wrap_rating_star">
                <div class="star-rating">
                  <label
                    v-for="rating in ratings"
                    :key="rating"
                    :class="{
                      'is-selected':
                        item.rating >= rating && item.rating !== null,
                    }"
                    class="star-rating__star"
                    >★</label
                  >
                </div>
                <span>(Reviews: {{ item.reviews_count }})</span>
              </div>
            </div>
          </div>
        </template>
        <template slot="contact" slot-scope="{ item }">
          <div>{{ item.email }}</div>
          <div>{{ item.phone }}</div>
          <a v-if="item.skype" :href="`skypecall:${item.skype}`">
            <i class="icon-skype"></i>
            {{ item.skype }}
          </a>
        </template>
      </admin-table>
    </div>
  </layout>
</template>

<script>
import { AdminTable } from 'stylemix-vue-admin'
import DriversApi from './Api'
import Avatar from 'vue-avatar'
import { VIEW_DRIVERS_SCHEDULE } from '../constants/permissions'

const resourceBase = 'drivers'

export default {
  name: 'Drivers',

  components: {
    AdminTable,
    Avatar,
  },

  data() {
    return {
      ratings: [1, 2, 3, 4, 5],
      value: 0,
      // Table resource configuration
      tableProps: {
        base: resourceBase,
        apiBuilder: () => {
          return new DriversApi().setParameter(
            'division_id',
            this.currentDivision.id
          )
        },
        sortBy: 'created_at',
        sortDesc: true,
        perPage: 9,
        columns: [
          {
            key: 'id',
            label: this.$t('general.id'),
            sortable: true,
          },
          {
            key: 'name',
            label: this.$t('drivers.driver_name'),
            //sortable: true,
          },
          {
            key: 'license_expires',
            label: this.$t('drivers.license_expire'),
            component: 'value-date',
            config: {
              time: false,
            },
            sortable: true,
          },
          {
            key: 'contact',
            label: this.$t('drivers.contacts'),
          },
          {
            key: 'created_at',
            label: this.$t('drivers.created'),
            component: 'value-date',
            sortable: true,
            config: {
              stacked: true,
            },
          },
          // define column fields here
        ],

        // override search fields here using fields schema
        // searchFields: [
        // ],

        // define custom row actions
        // eslint-disable-next-line no-unused-vars
        rowActions: (item) => {
          let actions = []

          if (
            this.$allows(`${resourceBase}.update`) ||
            this.$allows(`${resourceBase}.serve`) ||
            this.$allows(`${resourceBase}.view`)
          ) {
            actions.push('edit')
          }
          if (
            this.$allows(`${resourceBase}.delete`) ||
            this.$allows(`${resourceBase}.serve`)
          ) {
            actions.push('delete')
          }

          return actions
        },

        // define custom bulk actions
        bulkActions() {
          return []
        },
      },
    }
  },

  computed: {
    // Page header actions
    actions() {
      const actions = []

      if (this.$allows(VIEW_DRIVERS_SCHEDULE)) {
        actions.push({
          id: 'schedule',
          text: this.$t('drivers.schedule'),
          icon: 'icon-calendar2',
          onClick: () => {
            this.$router.push({
              name: `${resourceBase}.schedule`,
            })
          },
        })
      }

      if (
        this.$allows(`${resourceBase}.create`) ||
        this.$allows(`${resourceBase}.serve`)
      ) {
        actions.push({
          id: 'create',
          text: this.$t('general.add_new'),
          icon: 'icon-plus-circle2',
          onClick: () => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.$router.push({
              name: `${resourceBase}.create`,
            })
          },
        })
      }

      return actions
    },
  },

  watch: {
    currentDivision() {
      this.$refs.table && this.$refs.table.reset()
    },
  },
}
</script>
